// extracted by mini-css-extract-plugin
export default {"sigContainer":"styles_sigContainer__wdntD","sigPad":"styles_sigPad__XB5Oi","signButtons":"styles_signButtons__7CD9T","sigImage":"styles_sigImage__hYT0d"};